import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

const COLORS = { instagram: "#FF2E93", youtube: "#EF4444", tiktok: "#111827", x: "#6B7280", twitch: "#9146FF", pinterest: "#E60023" };
const NAMES = { instagram: "Instagram", youtube: "YouTube", tiktok: "TikTok", x: "X", twitch: "Twitch", pinterest: "Pinterest" };
const compact = (n) => Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(n);

export function FollowerGrowthChart({ userId }) {
  const [series, setSeries] = useState(null);
  useEffect(() => {
    api.get(`/influencers/${userId}/growth`).then((r) => setSeries(r.data)).catch(() => setSeries({}));
  }, [userId]);
  if (!series) return null;
  const platforms = Object.keys(series).filter((p) => series[p].length);
  const byDate = {};
  platforms.forEach((p) => series[p].forEach(({ date, followers }) => { byDate[date] = { ...(byDate[date] || { date }), [p]: followers }; }));
  const data = Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date));
  return (
    <div className="mt-4 rounded-xl border border-border bg-background p-3" data-testid="follower-growth-chart">
      <p className="text-xs font-semibold text-muted-foreground mb-2 flex items-center gap-1"><TrendingUp className="h-3.5 w-3.5 text-neon-pink" /> Follower growth</p>
      {data.length < 2 ? (
        <p className="text-xs text-muted-foreground" data-testid="follower-growth-empty">Growth appears after at least two weekly checks.</p>
      ) : (
        <div className="h-40">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 8, left: -10, bottom: 0 }}>
              <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 10 }} tickFormatter={compact} width={48} />
              <Tooltip formatter={(v, n) => [Number(v).toLocaleString(), NAMES[n] || n]} />
              <Legend formatter={(n) => NAMES[n] || n} wrapperStyle={{ fontSize: 11 }} />
              {platforms.map((p) => <Line key={p} type="monotone" dataKey={p} stroke={COLORS[p] || "#FF2E93"} strokeWidth={2} dot={{ r: 2 }} connectNulls />)}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
